import React from "react";
import logo from "../SatyamPandey.png";

const About = () => {
  return (
    <section className="section about-section about">
      <img src={logo} alt="Satyam Pandey logo" className="satyamlogo" />
      <div className="satyaminfo">
        <h1 className="satyam">Satyam Pandey</h1>
        <a
          href="https://www.linkedin.com/in/satyampandey9811/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Linked in
        </a>
      </div>
    </section>
  );
};

export default About;
